import getAsyncGeneratorFunction from './index.js';

/** @type {import('./index.d.mts').default} */
export default getAsyncGeneratorFunction;
